import { SettingsProvider, useSettingsContext } from './contex'
import { UpdateModal } from './UpdateModal'

export const FeatureSettings = {
  UpdateModal,
  useContext: useSettingsContext,
  Provider: SettingsProvider,
}
